import { useRef } from 'react';
function useFirstMountState() {
    const isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
export default useFirstMountState;
//# sourceMappingURL=use-first-mount-state.js.map